import React from "react";
import { Route, Routes } from "react-router-dom";
import routes from "../../../common/routes";

import FundWalletForm from "./FundWalletForm";
import WithdrawalForm from "./WithdrawalForm";
import WithdrawalThreshold from "./WithdrawalThreshold";

function UtilityModal() {
  return (
    <Routes>
      {/* wallet fund */}

      <Route
        path={
          routes.protected.applications.app.vas_services.utility.threshold.index
        }
        element={<WithdrawalThreshold />}
      />
      <Route
        path={routes.protected.applications.app.vas_services.utility.fund.index}
        element={<FundWalletForm />}
      />
      <Route
        path={
          routes.protected.applications.app.vas_services.utility.withdraw.index
        }
        element={<WithdrawalForm />}
      />
    </Routes>
  );
}

export default UtilityModal;
